import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { ITimezoneOption, allTimezones, useTimezoneSelect } from 'react-timezone-select';

export const useTimezoneOptions = (): DropdownItemProps<string>[] => {
  const { options: timezones } = useTimezoneSelect({
    labelStyle: 'original',
    displayValue: 'UTC',
    ...allTimezones,
  });

  const items = useMemo<DropdownItemProps<string>[]>(() => {
    return timezones.map(({ value, label }: ITimezoneOption) => {
      return {
        key: value,
        value,
        stringValue: value,
        label,
      };
    });
  }, [timezones]);

  return items;
};

export default useTimezoneOptions;
